import { modalAnatomy as parts } from '@chakra-ui/anatomy'
import { createMultiStyleConfigHelpers } from '@chakra-ui/styled-system'

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(parts.keys)

const baseStyle = definePartsStyle({
  dialog: {
    bgColor: '#F5F5F5',
    boxShadow: '0px 4px 40px 0px rgba(0, 0, 0, 0.25)',
    rounded: '2.5rem',
    p: 3,
    willChange: 'transform, opacity',
  },
  overlay: {
    bgColor: 'whiteAlpha.600',
    backdropFilter: 'auto',
    willChange: 'transform, opacity',
  },
  closeButton: {
    rounded: 'full',
    mt: 5,
    mr: 5,
  },
  header: {
    fontSize: '24px',
  },
  footer: {
    justifyContent: 'flex-start',
    gap: 3,
  },
})

export const modalTheme = defineMultiStyleConfig({
  baseStyle,
})
